import { StrictMode } from 'react';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client/react';
import { Provider as ReduxProvider } from 'react-redux';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router';

import App from './app';
import { store } from './state';
import { initializeSocket } from './lib/socket';
import { routesSection } from './routes/sections';
import { apolloClient } from './lib/apollo-client';
import { ErrorBoundary } from './routes/components';

// ----------------------------------------------------------------------

// Initialize websocket connection with Redux store
initializeSocket(store.dispatch);

// Capture ?ucc= referral code before React Router changes the URL.
// This must happen synchronously before root.render() so it survives redirects.
(function captureUcc() {
  const ucc = new URLSearchParams(window.location.search).get('ucc');
  if (ucc) {
    localStorage.setItem('cello_ucc', ucc);
  }
})();

// ----------------------------------------------------------------------

Sentry.init({
  dsn: 'https://fd2846a25495000837125a40aca6247f@o125882.ingest.us.sentry.io/4510288903012352',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: 'system',
      autoInject: false,
    }),
  ],
});

// ----------------------------------------------------------------------

const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorBoundary />,
    children: routesSection,
  },
]);

const root = createRoot(document.getElementById('root')!);

root.render(
  <StrictMode>
    <ApolloProvider client={apolloClient}>
      <ReduxProvider store={store}>
        <RouterProvider router={router} />
      </ReduxProvider>
    </ApolloProvider>
  </StrictMode>
);
